import React, { useState, useEffect } from "react";
import { Divider, Grid, CircularProgress } from "@material-ui/core";
import moment from "moment";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Card, CardContent, CardActions } from "../../components/Card";
import Table from "../../components/Table";
import PageItem from "../../components/PageItem";
import Button from "../../components/Button";
import LoadingModal from "../../components/LoadingModal";
import { Select } from "../../components/Form";
import { useAlert } from "../../components/Alert";
import { identity } from "../../components/utils";

const GET_ARTICLES = gql`
  query articles(
    $type: ArticleType
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    articles(type: $type, latest: $latest, pageSize: $pageSize, page: $page) {
      count
      pageCount
      contents {
        id
        title
        imageUrl
        contents {
          id
          type
          body
        }
        createdAt
        type
      }
    }
  }
`;
const DELETE_ARTICLE = gql`
  mutation deleteArticle($id: Int!) {
    deleteArticle(id: $id)
  }
`;
export default function NewInfoTable({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  const typeArray = [
    {
      label: "全部",
      value: null,
    },
    {
      label: "媒體報導",
      value: "MEDIA_COVERAGE",
    },
    {
      label: "富屋榮耀",
      value: "GLORY",
    },
    {
      label: "富屋豹報",
      value: "ANNOUNCEMENT",
    },
  ];
  const [typeObject, setTypeObject] = useState({
    label: "全部",
    value: null,
  });
  const [page, setPage] = useState(1);
  const [pageMax, setPageMax] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [pageArray, setPageArray] = useState([]);

  const [deleteArticle, { loading: deleteArticleLoading }] = useMutation(
    DELETE_ARTICLE,
    {
      onCompleted({ deleteArticle }) {
        if (deleteArticle) {
          return Alert.alert("", "刪除成功！", [
            {
              text: "確定",
              onPress: refetch,
              type: "ok",
            },
          ]);
        } else {
          return Alert.alert("", "刪除失敗！", [
            {
              text: "確定",
              type: "ok",
            },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );

  function _delete(id) {
    Alert.alert("", "確定要刪除？", [
      {
        text: "確定",
        onPress: () => deleteArticle({ variables: { id } }),
        type: "ok",
      },
      { text: "取消", type: "cancel" },
    ]);
  }
  const { data, refetch, loading } = useQuery(GET_ARTICLES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      type: typeObject.value,
      latest: false,
      pageSize,
      page,
    },
    onCompleted({ articles }) {
      setPageMax(articles.pageCount);
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  useEffect(() => {
    let newArray = [];
    for (let i = 1; i <= pageMax; i++) {
      newArray.push(i);
    }
    setPageArray(newArray);
  }, [pageMax]);

  useEffect(() => {
    if (data) {
      if (!data.articles.contents[0] && page > 1) {
        setPage(page - 1);
      }
    }
  }, [data]);
  function getType(value) {
    switch (value) {
      case "MEDIA_COVERAGE":
        return "媒體報導";
      case "GLORY":
        return "富屋榮耀";
      case "ANNOUNCEMENT":
        return "富屋豹報";
      default:
        return null;
    }
  }
  if (loading) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={deleteArticleLoading} />
        <CardContent>
          <Grid container spacing={1} justify="space-between">
            <Grid item xs={12} sm={3}>
              <Select
                items={typeArray}
                value={typeObject}
                onChange={(e, v) => {
                  if (v) {
                    setTypeObject(v);
                  } else {
                    setTypeObject({ label: "全部", value: null });
                  }
                }}
              />
            </Grid>
            {identity && (
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onPress={() => onChangeSelect()}
                >
                  新增消息
                </Button>
              </Grid>
            )}
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Table
            data={data ? data.articles.contents : []}
            tableWidth={2}
            header={
              identity
                ? ["類別", "標題", "時間", "操作"]
                : ["類別", "標題", "時間"]
            }
            columns={
              identity
                ? [
                    (item) => getType(item.type),
                    "title",
                    (item) => moment(item.createdAt).format("YYYY-MM-DD"),
                    (item) => (
                      <Button
                        color="primary"
                        variant="contained"
                        onPress={(event) => {
                          event.stopPropagation();
                          _delete(item.id);
                        }}
                      >
                        刪除
                      </Button>
                    ),
                  ]
                : [
                    (item) => getType(item.type),
                    "title",
                    (item) => moment(item.createdAt).format("YYYY-MM-DD"),
                  ]
            }
            onPress={(item) => onChangeSelect(item, "edit")}
          />
        </CardContent>
        <CardActions>
          <PageItem
            data={pageArray}
            page={page}
            onChangePage={(e) => setPage(e)}
          />
        </CardActions>
      </Card>
    );
  }
}
